"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var request = require("superagent");
var variables_1 = require("./variables");
/**
 * Fleet API Service
 * @class BaseClient
 */
var BaseClient = (function () {
    function BaseClient() {
        this.url = '';
        this.throttle = null;
        this.errorHandlers = [];
        /** Set the access token when the user had been authenticated */
        this.accessToken = null;
        this.url = variables_1.API_BASE_PATH;
    }
    BaseClient.prototype._addErrorHandler = function (handler) {
        this.errorHandlers.push(handler);
    };
    BaseClient.prototype.request = function (method, url, body, headers, queryParameters, form) {
        var _this = this;
        if (!this.url)
            return Promise.reject(new Error("No API endpoint defined for " + method + " " + url + "."));
        return new Promise(function (resolve, reject) {
            if (_this.logger) {
                _this.logger.log("[" + method + "] " + url);
            }
            var req = request(method, url).query(queryParameters);
            if (_this.throttle) {
                _this.throttle.apply(req);
            }
            Object.keys(headers).forEach(function (key) {
                req.set(key, headers[key]);
            });
            if (_this.accessToken) {
                req.set('x-access-token', _this.accessToken);
            }
            if (body) {
                req.send(body);
            }
            if (typeof body === 'object' &&
                !(body.constructor.name === 'Buffer')) {
                req.set('Content-Type', 'application/json');
            }
            if (Object.keys(form).length > 0) {
                req.type('form');
                req.send(form);
            }
            req.end(function (error, response) {
                if (error || !response.ok) {
                    var errorResponse_1 = error.response;
                    // move the error to a native error if it exists.
                    if (error.response && error.response.body) {
                        error = error.response.body;
                    }
                    // convert the error to a real error object
                    var err_1 = new Error();
                    err_1.message = error.message || error.name;
                    err_1.name = error.name || err_1.name;
                    err_1.stack = error.stack || err_1.stack;
                    err_1['data'] =
                        error.data ||
                            (error.fields && { fields: error.fields }); // convert swagger result into a data property
                    err_1['status'] = error.status;
                    if (error.crossDomain) {
                        err_1['status'] = 0;
                    }
                    reject(err_1);
                    _this.errorHandlers.forEach(function (handler) {
                        return handler(err_1, errorResponse_1);
                    });
                }
                else {
                    resolve(response);
                }
            });
        });
    };
    return BaseClient;
}());
exports.BaseClient = BaseClient;
//# sourceMappingURL=base.js.map